// Short names for a class's clients, in the order given: the first name
// (the server's, else the first word of the full name). Two clients of one
// class with the same first name get their last name's initial ("Ayu L.",
// "Ayu P."), or their full names when the initials clash too. Used by the
// calendar block and the schedule list's Klien column.
export const clientShortNames = (
  names: string[],
  firstNames?: string[]
): string[] => {
  const firsts = names.map((full, i) =>
    firstNames?.length === names.length
      ? firstNames[i]
      : full.trim().split(/\s+/)[0]
  );
  const counts = (labels: string[]) => {
    const byLabel = new Map<string, number>();
    labels.forEach((l) => byLabel.set(l, (byLabel.get(l) ?? 0) + 1));
    return byLabel;
  };

  const firstCounts = counts(firsts);
  const withInitials = firsts.map((first, i) => {
    if ((firstCounts.get(first) ?? 0) < 2) return first;
    // The next word with a letter in it ("Rina Kusuma / Rio" -> "K").
    const next = names[i]
      .trim()
      .split(/\s+/)
      .slice(1)
      .find((word) => /[A-Za-zÀ-ÿ]/.test(word));
    return next ? `${first} ${next[0].toUpperCase()}.` : names[i];
  });

  const labelCounts = counts(withInitials);
  return withInitials.map((label, i) =>
    (labelCounts.get(label) ?? 0) > 1 ? names[i] : label
  );
};
